import { render } from "./VabChartPie.vue?vue&type=template&id=e74613cc"
import script from "./VabChartPie.vue?vue&type=script&lang=js"
export * from "./VabChartPie.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/other/echarts/components/VabChartPie.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e74613cc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e74613cc', __exports__)) {
    console.log('reload')
    api.reload('e74613cc', __exports__)
  }
  
  module.hot.accept("./VabChartPie.vue?vue&type=template&id=e74613cc", () => {
    console.log('re-render')
    api.rerender('e74613cc', render)
  })

}


export default __exports__